var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-reason"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_c('div',{staticClass:"description"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.sentence)}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }